export const SOLUTIONS = [
  "apollo",
  "avis",
  "fenix",
  "friday",
  "mercurio",
  "plv",
  "pmt",
  "tienda",
  "timbo",
  "otros",
];

export const COUNTRIES = [
  "TODOS",
  "Argentina",
  "Avis Zona",
  "Bolivia",
  "Brasil",
  "Canada",
  "CERAN",
  "Chile",
  "Colombia",
  "Costa Rica",
  "Ecuador",
  "El Salvador",
  "España",
  "Guatemala",
  "Honduras",
  "Mexico",
  "Nicaragua",
  "Panamá",
  "Paraguay",
  "Perú",

  "Uruguay",
  "Venezuela",
  "Zona",
];
